import { render, staticRenderFns } from "./SingleOrganization.vue?vue&type=template&id=4bc6ab75&"
import script from "./SingleOrganization.vue?vue&type=script&lang=js&"
export * from "./SingleOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports